import React, { useState, useRef, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { faChevronUp } from "@fortawesome/free-solid-svg-icons";
import CountUp from "react-countup";

const Section6 = ({ url }) => {

  const [counterOn, setCounterOn] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setCounterOn(true);
        }
      },
      { threshold: 0.4 } // triggers when ~40% visible
    );

    if (sectionRef.current) observer.observe(sectionRef.current);

    return () => observer.disconnect();
  }, []);
  
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (idx) => setOpenIndex(openIndex === idx ? null : idx);

const faqs = [
  {
    question:
      "We tried outsourcing before and it did not work.",
    answer:
      "We hear this on almost every discovery call. Bad experiences usually come from vague scope, poor communication, or a team that optimized for delivery speed over your actual outcome. Our process is built specifically to prevent all three. Every scope document is fully transparent before any contract is signed.",
  },
  {
    question:
      "How do we know we can trust an external team with our systems?",
    answer:
      "You should not trust us on day one. That is why the discovery call costs nothing. We earn trust through transparency, documentation, and results at every stage before you scale the engagement. Every scope document, architecture decision, and cost breakdown is visible to you before any commitment is made.",
  },
  {
    question:
      "Our current system is working fine. Why change it now?",
    answer:
      "That is a valid position. If after our call you still believe your current setup is the right choice for the next three years, we will tell you that directly. We are not here to sell a project. We are here to solve a problem. If there is no problem worth solving, there is no project worth building.",
  },
];

  const stats = [
    { end: 100, suffix: "+", label: "Software Deployments" },
    { end: 5, suffix: "+", label: "Countries Served" },
    { end: 2, suffix: "M+", label: "Operational Impact" },
    { end: 90, suffix: "%", label: "Return Engagement Rate" },
  ];

  return (
    <section className="home-section-6">
      <div className="container overflow-hidden">

        {/* ── FAQ ── */}
        <h2 className="s6-title" data-aos="fade-up">
          We Know What You Are Thinking
        </h2>
        <p className="s6-subtitle" data-aos="fade-up" data-aos-delay="100">
          Naming the hesitation directly is the fastest way to overcome it. 
          Most landing pages avoid this section. That is exactly why you should not.
        </p>

        <div className="s6-faq-list" data-aos="fade-up" data-aos-delay="200">
          {faqs.map((faq, idx) => (
            <div
            className={`s6-faq-item ${openIndex === idx ? "s6-faq-item--open" : ""}`}
            key={idx}
            onClick={() => toggle(idx)}
            >
            <div className="s6-faq-row">
                <span className="s6-faq-question">{faq.question}</span>
               <span className="s6-faq-icon">{openIndex === idx ?  <FontAwesomeIcon icon={faChevronUp} /> :  <FontAwesomeIcon icon={faChevronDown} />}</span>
            </div>
            <div className="s6-faq-answer">
                {faq.answer}
            </div>
            </div>
          ))}
        </div>

        {/* ── STATS ── */}
        <h2 className="s6-stats-title" data-aos="fade-up" data-aos-delay="100" ref={sectionRef}>
          Trusted by Businesses Across Industries
        </h2>

        <div className="s6-stats-grid" data-aos="fade-up" data-aos-delay="200">
          {stats.map((stat, idx) => (
            <div className="s6-stat-item" key={idx}>
              {/* <span className="s6-stat-number overflow-hidden">{stat.number}</span>
              <span className="s6-stat-label">
                {stat.label.split("\n").map((line, i) => (
                  <React.Fragment key={i}>{line}{i === 0 && <br />}</React.Fragment>
                ))}
              </span> */}
              <span className="s6-stat-number overflow-hidden">
                {counterOn && (
                  <CountUp
                    start={0}
                    end={stat.end}
                    duration={2}
                    separator=","
                  />
                )}
                {stat.suffix}
              </span>

              <span className="s6-stat-label">
                {stat.label}
              </span>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Section6;